import { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { find, includes, map } from "lodash"
import classNames from "classnames"
import { OPTIONS_TOGGLE_ITEM } from "helpers/shapes"
import useArrayRef from "hooks/array-ref"
import "./styles.scss"

const moveAndResize = (element, left, width) => {
  element.style.left = `${left.toString()}px`
  element.style.width = `${width.toString()}px`
}

export default function OptionsToggle({ selectedValue, items, onSelect }) {
  const backgroundRef = useRef()
  const [toggleRefs, setToggleRef] = useArrayRef()

  useEffect(() => {
    if (backgroundRef.current) {
      const activeToggle = find(toggleRefs.current, toggle => includes(toggle.classList, "active"))
      moveAndResize(backgroundRef.current, activeToggle.offsetLeft, activeToggle.offsetWidth)
    }
  }, [selectedValue, backgroundRef, toggleRefs])

  const handleClick = (action) => {
    moveAndResize(backgroundRef.current, action.currentTarget.offsetLeft, action.currentTarget.offsetWidth)
    const value = action.currentTarget.dataset.value
    onSelect(value)
  }

  return (
    <div className="components_options-toggle">
      <span ref={backgroundRef} className="selected-background" />
      {map(items, ({ value, label }) => <span
        ref={setToggleRef}
        key={`toggle-button-${value}`}
        data-value={value}
        onClick={handleClick}
        className={classNames("toggle-button", selectedValue === value ? "active" : "")}
      >
        {label}
      </span>)}
    </div>
  )
}

OptionsToggle.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(OPTIONS_TOGGLE_ITEM),
  onSelect: PropTypes.func.isRequired,
}
